module.exports = __webpack_public_path__ + "assets/img/wh5_p10.d43a4c67.png";